import { render, staticRenderFns } from "./Profile2FA.vue?vue&type=template&id=ad36c808"
import script from "./Profile2FA.vue?vue&type=script&lang=js"
export * from "./Profile2FA.vue?vue&type=script&lang=js"
import style0 from "./Profile2FA.vue?vue&type=style&index=0&id=ad36c808&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports